import { useCompaniesByCustomerId } from "./data/useCompaniesByCustomerId";
import { LOCALSTORAGE_KEYS } from "./shared/constants";
import { useEffect, useState } from "react";
import { Region } from "./shared/interfaces/Region";
import { CompanyDropdown } from "./CompanyDropdown";

interface Props {
  customerId?: number | undefined;
  onCompanyChange: (company: string) => void;
  showLabel?: boolean;
}

const companyStorageKey = LOCALSTORAGE_KEYS.company;

export function PersistedCompanyDropdown(props: Props) {
  const { customerId, onCompanyChange } = props;

  const companies = useCompaniesByCustomerId(customerId);

  const [selectedCompanyName, setSelectedCompanyName] = useState<string | undefined>();

  useEffect(() => {
    const companyName = localStorage.getItem(companyStorageKey);
    const storedCompany = companies.data?.find((company: Region) => company.name === companyName);
    if (storedCompany && selectedCompanyName !== storedCompany.name) {
      storedCompany && setSelectedCompanyName(storedCompany.name);
      storedCompany && onCompanyChange(storedCompany.name);
    }
  }, [companies.data, onCompanyChange, selectedCompanyName]);

  const handleChange = (company: string) => {
    localStorage.setItem(companyStorageKey, company);
    localStorage.removeItem(LOCALSTORAGE_KEYS.hvSubstation);
    setSelectedCompanyName(company);
    onCompanyChange(company);
  };

  return (
    <CompanyDropdown
      customerId={customerId}
      selectedCompanyName={selectedCompanyName}
      onCompanyChange={handleChange}
      showLabel
      showClear={true}
    />
  );
}
